<script setup lang="ts">
  import { ref } from 'vue'
  import { Cropper } from 'vue-advanced-cropper'
  import 'vue-advanced-cropper/dist/style.css'
  import Dialog from 'primevue/dialog'
  import Button from 'primevue/button'

  const { visible, imageUrl } = defineProps<{
    visible: boolean
    imageUrl: string
  }>()

  const emit = defineEmits<{
    'update:visible': [value: boolean]
    crop: [result: { file: File }]
  }>()

  const cropperRef = ref()

  const handleCrop = async () => {
    if (!cropperRef.value) return

    const { canvas } = cropperRef.value.getResult()

    // Convert canvas to blob
    const blob = await new Promise<Blob>((resolve) => {
      canvas.toBlob((blob: Blob) => {
        resolve(blob)
      }, 'image/jpeg', 1.0)
    })

    // Create file from blob
    const originalFilename = imageUrl.split('/').pop() || 'cropped.jpg'
    const file = new File([blob], originalFilename, { type: 'image/jpeg' })

    emit('crop', { file })
    emit('update:visible', false)
  }

  const handleCancel = () => {
    emit('update:visible', false)
  }
</script>

<template>
  <Dialog :visible="visible" @update:visible="(val: boolean) => emit('update:visible', val)" modal
    :style="{ width: '90vw' }" header="Afbeelding bijsnijden" @hide="handleCancel">
    <div class="w-full h-[60vh] bg-background-200">
      <Cropper ref="cropperRef" class="h-full w-full" :src="imageUrl" :stencil-props="{
        aspectRatio: 1 / 1,
      }" />
    </div>
    <template #footer>
      <div class="flex justify-end gap-2">
        <Button label="Annuleren" severity="secondary" @click="handleCancel" />
        <Button label="Toepassen" @click="handleCrop" />
      </div>
    </template>
  </Dialog>
</template>
